import { Directive, HostListener, Optional, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[type="text"], input[type="email"], input[type="search"], input[type="url"], input[type="number"]',
})
export class TrimOnPasteDirective {
  constructor(
    @Optional() private ngControl: NgControl | null,
    private el: ElementRef<HTMLInputElement>
  ) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const isFullSelection = input.value.length > 0 && start === 0 && end === input.value.length;

    if (input.value.length > 0 && !isFullSelection) {
      return;
    }

    const raw = event.clipboardData?.getData('text') ?? '';
    const trimmed = raw.trim();

    const before = input.value.substring(0, start);
    const after = input.value.substring(end);
    const newVal = before + trimmed + after;

    event.preventDefault();

    if (typeof document.execCommand === 'function') {
      document.execCommand('insertText', false, trimmed);
    } else if (this.ngControl?.control) {
      this.ngControl.control.setValue(newVal);
    } else {
      input.value = newVal;
    }

    setTimeout(() => {
      const caret = start + trimmed.length;
      input.setSelectionRange(caret, caret);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
}
